import { Music24Capabilities } from 'fym-common/src/license/music24Plans';

/**
 * The plan note under "Add the song audio". Free and the trial both make low-res previews with
 * the Music24 mark (`previewRenders`), but only Free lacks the full-song videos: the trial has
 * Pro limits. So the trial gets its own note, and a paid plan gets none.
 */
export function audioPreviewNote(
  capabilities: Pick<Music24Capabilities, 'plan' | 'previewRenders'>
): 'free' | 'trial' | null {
  if (!capabilities.previewRenders) {
    return null;
  }
  return capabilities.plan === 'trial' ? 'trial' : 'free';
}
